export const UPDATE_MYPLAYLISTDATA = "UPDATE_MYPLAYLISTDATA";
export const UPDATE_PLAYLISTDATACOUNT="UPDATE_PLAYLISTDATACOUNT";
export const UPDATE_HASNEXTPAGE ="UPDATE_HASNEXTPAGE";